export default __webpack_public_path__ + "c45ad9491cb47540a039021a234330f4.svg";